import { registerComponent as Bt } from "@aileron/icon";
import { registerComponent as Mt } from "@aileron/listbox";
import { unsafeCSS as kt, LitElement as Vt, nothing as tt } from "lit";
import { unsafeStatic as zt, html as Ft } from "lit/static-html.js";
import { property as y, state as P, query as q } from "lit/decorators.js";
function et(t, e, i) {
  const r = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...i
  });
  return t.dispatchEvent(r), r;
}
const Ht = (t) => {
  class e extends t {
    constructor(...r) {
      super(...r), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const n = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(n.getElementsByTagName("link")).findIndex(
        (a) => a.href === this.fontLink
      ) === -1) {
        const a = document.createElement("link");
        a.href = this.fontLink, a.rel = "stylesheet", document.head.appendChild(a);
      }
    }
  }
  return e;
}, Wt = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.static{position:static}.absolute{position:absolute}.relative{position:relative}.block{display:block}.inline{display:inline}.flex{display:flex}.table{display:table}.hidden{display:none}.border{border-width:1px}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}', jt = kt(Wt), H = "aileron-color-scheme", mt = "aileron-color-scheme-change", It = (t) => {
  const i = class i extends t {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (n) => {
        n.detail ? this.setAttribute(H, n.detail) : this.removeAttribute(H);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        mt,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const n = document.documentElement.getAttribute(
        H
      );
      n && this.setAttribute(H, n);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        mt,
        this.handleSchemeSwitch
      );
    }
  };
  i.styles = [
    jt,
    t.styles ?? []
  ];
  let e = i;
  return e;
}, wt = It(Ht(Vt));
class Pt {
  constructor(e) {
    this.userAgent = e;
  }
  getDevice() {
    return this.userAgent.match(/iPad/i) ? "iPad" : this.userAgent.match(/iPhone/i) ? "iPhone" : this.userAgent.match(/iPod/i) ? "iPod" : this.userAgent.match(/Android/i) ? "Android" : "Unknown";
  }
  getBrowser() {
    return this.userAgent.match(/chrome|chromium|crios/i) ? "Chrome" : this.userAgent.match(/firefox|fxios/i) ? "Firefox" : this.userAgent.match(/opr\//i) ? "Opera" : this.userAgent.match(/edg/i) ? "Edge" : this.userAgent.match(/safari/i) ? "Safari" : "Unknown";
  }
}
const qt = ".aileron-dropdown{width:100%;font-family:AmericanSans Var;font-style:normal}.aileron-dropdown--open .aileron-dropdown__menu{display:block}.aileron-dropdown--open .aileron-dropdown__trigger{background-color:#e6ecef}.aileron-dropdown--error .aileron-dropdown__trigger{border-color:#d6001b}.aileron-dropdown--error .aileron-dropdown__trigger--ghost{border:.0625rem solid #D6001B}.aileron-dropdown__icon{margin-left:.5rem;min-width:1.5rem}.aileron-dropdown ::slotted(*){margin-right:.5rem}.aileron-dropdown__trigger-container{display:block}.aileron-dropdown__trigger{color:#006dc0;border:.0625rem solid #869199;border-radius:.25rem;line-height:1.5rem;display:flex;align-items:center;padding:.6875rem .6875rem .6875rem .9375rem;width:100%}.aileron-dropdown__trigger--ghost{color:#006dc0;border:0;padding:.75rem .5rem .75rem .75rem;width:auto;max-width:100%}.aileron-dropdown__trigger--secondary{color:#006dc0;border:.0625rem solid #006DC0;padding:.6875rem .4375rem .6875rem .6875rem;width:auto;max-width:100%}.aileron-dropdown__trigger--secondary.aileron-dropdown__trigger--small{padding:.3125rem .1875rem .3125rem .4375rem}.aileron-dropdown__trigger--ghost.aileron-dropdown__trigger--small{padding:.375rem .25rem .375rem .5rem}.aileron-dropdown__trigger--small .aileron-dropdown__icon{margin-left:.25rem}.aileron-dropdown__trigger ::slotted(*){margin-right:.5rem;margin-left:-PxToRem(4px)}.aileron-dropdown__trigger.aileron-dropdown__trigger--small ::slotted(*){margin-right:.25rem;margin-left:-PxToRem(4px)}.aileron-dropdown__trigger-label{text-align:left;flex-grow:1;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.aileron-dropdown__trigger:hover{background-color:#e0f2ff}.aileron-dropdown__trigger:focus{outline:.125rem solid #006DC0;outline-offset:.125rem}.aileron-dropdown__trigger:active{background-color:#d6edff}.aileron-dropdown__trigger:disabled{background-color:#edf1f3;color:#d0dae0;border:.0625rem solid #E6ECEF;cursor:not-allowed}.aileron-dropdown__trigger:disabled.aileron-dropdown__trigger:active{outline:0}.aileron-dropdown__trigger:disabled.aileron-dropdown__trigger--secondary{background-color:inherit}.aileron-dropdown__trigger:disabled.aileron-dropdown__trigger--ghost{background-color:inherit;border:0}.aileron-dropdown__error-message{align-items:flex-start;display:none;margin:.5rem 0;align-items:center;color:#d6001b;font-size:.75rem;font-weight:400;line-height:1rem}.aileron-dropdown__error-message :first-child{margin-right:.25rem}.aileron-dropdown__error-message span{flex:1}.aileron-dropdown--error .aileron-dropdown__error-message{display:flex}.aileron-dropdown__menu{display:none;border-radius:.25rem;box-shadow:0 3px 1px #0000001f,0 2px 2px #00000024,0 1px 5px #0003;overflow:hidden;padding:.5rem 0;background-color:#fff}", Ut = ["top", "right", "bottom", "left"], W = Math.min, $ = Math.max, j = Math.round, E = (t) => ({
  x: t,
  y: t
});
function U(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function K(t) {
  return t.split("-")[0];
}
function st(t) {
  return t.split("-")[1];
}
function Kt(t) {
  return t === "x" ? "y" : "x";
}
function Yt(t) {
  return t === "y" ? "height" : "width";
}
function Y(t) {
  return ["top", "bottom"].includes(K(t)) ? "y" : "x";
}
function Xt(t) {
  return Kt(Y(t));
}
function Gt(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Jt(t) {
  return typeof t != "number" ? Gt(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function I(t) {
  const {
    x: e,
    y: i,
    width: r,
    height: n
  } = t;
  return {
    width: r,
    height: n,
    top: i,
    left: e,
    right: e + r,
    bottom: i + n,
    x: e,
    y: i
  };
}
function bt(t, e, i) {
  let {
    reference: r,
    floating: n
  } = t;
  const o = Y(e), s = Xt(e), a = Yt(s), l = K(e), c = o === "y", d = r.x + r.width / 2 - n.width / 2, u = r.y + r.height / 2 - n.height / 2, g = r[a] / 2 - n[a] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: d,
        y: r.y - n.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - n.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (st(e)) {
    case "start":
      p[s] -= g * (i && c ? -1 : 1);
      break;
    case "end":
      p[s] += g * (i && c ? -1 : 1);
      break;
  }
  return p;
}
const Qt = async (t, e, i) => {
  const {
    placement: r = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: s
  } = i, a = o.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: n
  }), {
    x: d,
    y: u
  } = bt(c, r, l), g = r, p = {}, w = 0;
  for (let b = 0; b < a.length; b++) {
    const {
      name: x,
      fn: _
    } = a[b], {
      x: S,
      y: A,
      data: D,
      reset: v
    } = await _({
      x: d,
      y: u,
      initialPlacement: r,
      placement: g,
      strategy: n,
      middlewareData: p,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = S ?? d, u = A ?? u, p = {
      ...p,
      [x]: {
        ...p[x],
        ...D
      }
    }, v && w <= 50 && (w++, typeof v == "object" && (v.placement && (g = v.placement), v.rects && (c = v.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: n
    }) : v.rects), {
      x: d,
      y: u
    } = bt(c, g, l)), b = -1);
  }
  return {
    x: d,
    y: u,
    placement: g,
    strategy: n,
    middlewareData: p
  };
};
async function nt(t, e) {
  var i;
  e === void 0 && (e = {});
  const {
    x: r,
    y: n,
    platform: o,
    rects: s,
    elements: a,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: g = !1,
    padding: p = 0
  } = U(e, t), w = Jt(p), x = a[g ? u === "floating" ? "reference" : "floating" : u], _ = I(await o.getClippingRect({
    element: (i = await (o.isElement == null ? void 0 : o.isElement(x))) == null || i ? x : x.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), S = u === "floating" ? {
    x: r,
    y: n,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, A = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), D = await (o.isElement == null ? void 0 : o.isElement(A)) ? await (o.getScale == null ? void 0 : o.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, v = I(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: S,
    offsetParent: A,
    strategy: l
  }) : S);
  return {
    top: (_.top - v.top + w.top) / D.y,
    bottom: (v.bottom - _.bottom + w.bottom) / D.y,
    left: (_.left - v.left + w.left) / D.x,
    right: (v.right - _.right + w.right) / D.x
  };
}
function yt(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function xt(t) {
  return Ut.some((e) => t[e] >= 0);
}
const Zt = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: i
      } = e, {
        strategy: r = "referenceHidden",
        ...n
      } = U(t, e);
      switch (r) {
        case "referenceHidden": {
          const o = await nt(e, {
            ...n,
            elementContext: "reference"
          }), s = yt(o, i.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: xt(s)
            }
          };
        }
        case "escaped": {
          const o = await nt(e, {
            ...n,
            altBoundary: !0
          }), s = yt(o, i.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: xt(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function te(t, e) {
  const {
    placement: i,
    platform: r,
    elements: n
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(n.floating)), s = K(i), a = st(i), l = Y(i) === "y", c = ["left", "top"].includes(s) ? -1 : 1, d = o && l ? -1 : 1, u = U(e, t);
  let {
    mainAxis: g,
    crossAxis: p,
    alignmentAxis: w
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return a && typeof w == "number" && (p = a === "end" ? w * -1 : w), l ? {
    x: p * d,
    y: g * c
  } : {
    x: g * c,
    y: p * d
  };
}
const ee = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var i, r;
      const {
        x: n,
        y: o,
        placement: s,
        middlewareData: a
      } = e, l = await te(e, t);
      return s === ((i = a.offset) == null ? void 0 : i.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: n + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, ie = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var i, r;
      const {
        placement: n,
        rects: o,
        platform: s,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...c
      } = U(t, e), d = await nt(e, c), u = K(n), g = st(n), p = Y(n) === "y", {
        width: w,
        height: b
      } = o.floating;
      let x, _;
      u === "top" || u === "bottom" ? (x = u, _ = g === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (_ = u, x = g === "end" ? "top" : "bottom");
      const S = b - d.top - d.bottom, A = w - d.left - d.right, D = W(b - d[x], S), v = W(w - d[_], A), Rt = !e.middlewareData.shift;
      let Q = D, Z = v;
      if ((i = e.middlewareData.shift) != null && i.enabled.x && (Z = A), (r = e.middlewareData.shift) != null && r.enabled.y && (Q = S), Rt && !g) {
        const ft = $(d.left, 0), ht = $(d.right, 0), pt = $(d.top, 0), gt = $(d.bottom, 0);
        p ? Z = w - 2 * (ft !== 0 || ht !== 0 ? ft + ht : $(d.left, d.right)) : Q = b - 2 * (pt !== 0 || gt !== 0 ? pt + gt : $(d.top, d.bottom));
      }
      await l({
        ...e,
        availableWidth: Z,
        availableHeight: Q
      });
      const ut = await s.getDimensions(a.floating);
      return w !== ut.width || b !== ut.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function X() {
  return typeof window < "u";
}
function V(t) {
  return St(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function k(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function N(t) {
  var e;
  return (e = (St(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function St(t) {
  return X() ? t instanceof Node || t instanceof k(t).Node : !1;
}
function L(t) {
  return X() ? t instanceof Element || t instanceof k(t).Element : !1;
}
function O(t) {
  return X() ? t instanceof HTMLElement || t instanceof k(t).HTMLElement : !1;
}
function vt(t) {
  return !X() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof k(t).ShadowRoot;
}
function F(t) {
  const {
    overflow: e,
    overflowX: i,
    overflowY: r,
    display: n
  } = T(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + i) && !["inline", "contents"].includes(n);
}
function re(t) {
  return ["table", "td", "th"].includes(V(t));
}
function G(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function at(t) {
  const e = lt(), i = L(t) ? T(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => i[r] ? i[r] !== "none" : !1) || (i.containerType ? i.containerType !== "normal" : !1) || !e && (i.backdropFilter ? i.backdropFilter !== "none" : !1) || !e && (i.filter ? i.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (i.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (i.contain || "").includes(r));
}
function ne(t) {
  let e = R(t);
  for (; O(e) && !M(e); ) {
    if (at(e))
      return e;
    if (G(e))
      return null;
    e = R(e);
  }
  return null;
}
function lt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function M(t) {
  return ["html", "body", "#document"].includes(V(t));
}
function T(t) {
  return k(t).getComputedStyle(t);
}
function J(t) {
  return L(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function R(t) {
  if (V(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    vt(t) && t.host || // Fallback.
    N(t)
  );
  return vt(e) ? e.host : e;
}
function At(t) {
  const e = R(t);
  return M(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : O(e) && F(e) ? e : At(e);
}
function $t(t, e, i) {
  var r;
  e === void 0 && (e = []);
  const n = At(t), o = n === ((r = t.ownerDocument) == null ? void 0 : r.body), s = k(n);
  return o ? (ot(s), e.concat(s, s.visualViewport || [], F(n) ? n : [], [])) : e.concat(n, $t(n, []));
}
function ot(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Lt(t) {
  const e = T(t);
  let i = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const n = O(t), o = n ? t.offsetWidth : i, s = n ? t.offsetHeight : r, a = j(i) !== o || j(r) !== s;
  return a && (i = o, r = s), {
    width: i,
    height: r,
    $: a
  };
}
function Tt(t) {
  return L(t) ? t : t.contextElement;
}
function B(t) {
  const e = Tt(t);
  if (!O(e))
    return E(1);
  const i = e.getBoundingClientRect(), {
    width: r,
    height: n,
    $: o
  } = Lt(e);
  let s = (o ? j(i.width) : i.width) / r, a = (o ? j(i.height) : i.height) / n;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const oe = /* @__PURE__ */ E(0);
function Dt(t) {
  const e = k(t);
  return !lt() || !e.visualViewport ? oe : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function se(t, e, i) {
  return e === void 0 && (e = !1), !i || e && i !== k(t) ? !1 : e;
}
function z(t, e, i, r) {
  e === void 0 && (e = !1), i === void 0 && (i = !1);
  const n = t.getBoundingClientRect(), o = Tt(t);
  let s = E(1);
  e && (r ? L(r) && (s = B(r)) : s = B(t));
  const a = se(o, i, r) ? Dt(o) : E(0);
  let l = (n.left + a.x) / s.x, c = (n.top + a.y) / s.y, d = n.width / s.x, u = n.height / s.y;
  if (o) {
    const g = k(o), p = r && L(r) ? k(r) : r;
    let w = g, b = ot(w);
    for (; b && r && p !== w; ) {
      const x = B(b), _ = b.getBoundingClientRect(), S = T(b), A = _.left + (b.clientLeft + parseFloat(S.paddingLeft)) * x.x, D = _.top + (b.clientTop + parseFloat(S.paddingTop)) * x.y;
      l *= x.x, c *= x.y, d *= x.x, u *= x.y, l += A, c += D, w = k(b), b = ot(w);
    }
  }
  return I({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function ct(t, e) {
  const i = J(t).scrollLeft;
  return e ? e.left + i : z(N(t)).left + i;
}
function Et(t, e, i) {
  i === void 0 && (i = !1);
  const r = t.getBoundingClientRect(), n = r.left + e.scrollLeft - (i ? 0 : (
    // RTL <body> scrollbar.
    ct(t, r)
  )), o = r.top + e.scrollTop;
  return {
    x: n,
    y: o
  };
}
function ae(t) {
  let {
    elements: e,
    rect: i,
    offsetParent: r,
    strategy: n
  } = t;
  const o = n === "fixed", s = N(r), a = e ? G(e.floating) : !1;
  if (r === s || a && o)
    return i;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = E(1);
  const d = E(0), u = O(r);
  if ((u || !u && !o) && ((V(r) !== "body" || F(s)) && (l = J(r)), O(r))) {
    const p = z(r);
    c = B(r), d.x = p.x + r.clientLeft, d.y = p.y + r.clientTop;
  }
  const g = s && !u && !o ? Et(s, l, !0) : E(0);
  return {
    width: i.width * c.x,
    height: i.height * c.y,
    x: i.x * c.x - l.scrollLeft * c.x + d.x + g.x,
    y: i.y * c.y - l.scrollTop * c.y + d.y + g.y
  };
}
function le(t) {
  return Array.from(t.getClientRects());
}
function ce(t) {
  const e = N(t), i = J(t), r = t.ownerDocument.body, n = $(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = $(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -i.scrollLeft + ct(t);
  const a = -i.scrollTop;
  return T(r).direction === "rtl" && (s += $(e.clientWidth, r.clientWidth) - n), {
    width: n,
    height: o,
    x: s,
    y: a
  };
}
function de(t, e) {
  const i = k(t), r = N(t), n = i.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (n) {
    o = n.width, s = n.height;
    const c = lt();
    (!c || c && e === "fixed") && (a = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function ue(t, e) {
  const i = z(t, !0, e === "fixed"), r = i.top + t.clientTop, n = i.left + t.clientLeft, o = O(t) ? B(t) : E(1), s = t.clientWidth * o.x, a = t.clientHeight * o.y, l = n * o.x, c = r * o.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function _t(t, e, i) {
  let r;
  if (e === "viewport")
    r = de(t, i);
  else if (e === "document")
    r = ce(N(t));
  else if (L(e))
    r = ue(e, i);
  else {
    const n = Dt(t);
    r = {
      x: e.x - n.x,
      y: e.y - n.y,
      width: e.width,
      height: e.height
    };
  }
  return I(r);
}
function Ot(t, e) {
  const i = R(t);
  return i === e || !L(i) || M(i) ? !1 : T(i).position === "fixed" || Ot(i, e);
}
function fe(t, e) {
  const i = e.get(t);
  if (i)
    return i;
  let r = $t(t, []).filter((a) => L(a) && V(a) !== "body"), n = null;
  const o = T(t).position === "fixed";
  let s = o ? R(t) : t;
  for (; L(s) && !M(s); ) {
    const a = T(s), l = at(s);
    !l && a.position === "fixed" && (n = null), (o ? !l && !n : !l && a.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || F(s) && !l && Ot(t, s)) ? r = r.filter((d) => d !== s) : n = a, s = R(s);
  }
  return e.set(t, r), r;
}
function he(t) {
  let {
    element: e,
    boundary: i,
    rootBoundary: r,
    strategy: n
  } = t;
  const s = [...i === "clippingAncestors" ? G(e) ? [] : fe(e, this._c) : [].concat(i), r], a = s[0], l = s.reduce((c, d) => {
    const u = _t(e, d, n);
    return c.top = $(u.top, c.top), c.right = W(u.right, c.right), c.bottom = W(u.bottom, c.bottom), c.left = $(u.left, c.left), c;
  }, _t(e, a, n));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function pe(t) {
  const {
    width: e,
    height: i
  } = Lt(t);
  return {
    width: e,
    height: i
  };
}
function ge(t, e, i) {
  const r = O(e), n = N(e), o = i === "fixed", s = z(t, !0, o, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = E(0);
  if (r || !r && !o)
    if ((V(e) !== "body" || F(n)) && (a = J(e)), r) {
      const g = z(e, !0, o, e);
      l.x = g.x + e.clientLeft, l.y = g.y + e.clientTop;
    } else n && (l.x = ct(n));
  const c = n && !r && !o ? Et(n, a) : E(0), d = s.left + a.scrollLeft - l.x - c.x, u = s.top + a.scrollTop - l.y - c.y;
  return {
    x: d,
    y: u,
    width: s.width,
    height: s.height
  };
}
function it(t) {
  return T(t).position === "static";
}
function Ct(t, e) {
  if (!O(t) || T(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let i = t.offsetParent;
  return N(t) === i && (i = i.ownerDocument.body), i;
}
function Nt(t, e) {
  const i = k(t);
  if (G(t))
    return i;
  if (!O(t)) {
    let n = R(t);
    for (; n && !M(n); ) {
      if (L(n) && !it(n))
        return n;
      n = R(n);
    }
    return i;
  }
  let r = Ct(t, e);
  for (; r && re(r) && it(r); )
    r = Ct(r, e);
  return r && M(r) && it(r) && !at(r) ? i : r || ne(t) || i;
}
const me = async function(t) {
  const e = this.getOffsetParent || Nt, i = this.getDimensions, r = await i(t.floating);
  return {
    reference: ge(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function we(t) {
  return T(t).direction === "rtl";
}
const be = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ae,
  getDocumentElement: N,
  getClippingRect: he,
  getOffsetParent: Nt,
  getElementRects: me,
  getClientRects: le,
  getDimensions: pe,
  getScale: B,
  isElement: L,
  isRTL: we
}, ye = ee, rt = ie, xe = Zt, ve = (t, e, i) => {
  const r = /* @__PURE__ */ new Map(), n = {
    platform: be,
    ...i
  }, o = {
    ...n.platform,
    _c: r
  };
  return Qt(t, e, {
    ...n,
    platform: o
  });
}, _e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let Ce = (t = 21) => {
  let e = "", i = crypto.getRandomValues(new Uint8Array(t |= 0));
  for (; t--; )
    e += _e[i[t] & 63];
  return e;
};
function ke(t, e) {
  const i = {
    waitUntilFirstUpdate: !1,
    ...e
  };
  return (r, n) => {
    const { update: o } = r;
    if (t in r) {
      const s = t;
      r.update = function(a) {
        if (a.has(s)) {
          const l = a.get(s), c = this[s];
          l !== c && (!i.waitUntilFirstUpdate || this.hasUpdated) && this[n](
            l,
            c
          );
        }
        o.call(this, a);
      };
    }
  };
}
var Se = Object.defineProperty, Ae = Object.getOwnPropertyDescriptor, h = (t, e, i, r) => {
  for (var n = r > 1 ? void 0 : r ? Ae(e, i) : e, o = t.length - 1, s; o >= 0; o--)
    (s = t[o]) && (n = (r ? s(e, i, n) : s(n)) || n);
  return r && n && Se(e, i, n), n;
};
const C = "aileron-dropdown", m = {
  root: C,
  menu: `${C}__menu`,
  triggerContainer: `${C}__trigger-container`,
  trigger: `${C}__trigger`,
  errorMessage: `${C}__error-message`,
  ghost: `${C}__trigger--ghost`,
  secondary: `${C}__trigger--secondary`,
  small: `${C}__trigger--small`,
  triggerLabel: `${C}__trigger-label`,
  icon: `${C}__icon`,
  prependIcon: `${C}__prepend-icon`,
  open: `${C}--open`,
  error: `${C}--error`
}, dt = class dt extends wt {
  constructor(e) {
    super(), this.options = [], this.includeSearch = !1, this.open = !1, this.value = "", this.ghost = !1, this.secondary = !1, this.small = !1, this.required = !1, this.triggerLabel = "Choose an option", this.errorMessage = "Option selection required", this.disabled = !1, this.error = !1, this.ariaLabel = null, this.ariaLabelledBy = null, this.ariaDescription = null, this.ariaDescribedBy = null, this.multiSelect = !1, this.fitContentMenu = !1, this._touched = !1, this._describedByIds = /* @__PURE__ */ new Set(), this.randomID = `adc-dropdown-${Ce(6)}`, this.displayName = "", this.labelText = "", this.handleSlotchange = (i) => {
      if (!this.secondary && !this.ghost) {
        const r = i.target.assignedNodes({ flatten: !0 });
        r.length > 0 && r.forEach((n) => n.remove());
      }
    }, this.positionMenu = () => {
      const i = [], r = this.error ? this.errorElement : this.trigger;
      !this.secondary && !this.ghost ? this.fitContentMenu ? rt({
        apply({ elements: n }) {
          Object.assign(n.floating.style);
        }
      }) : i.push(
        rt({
          apply({ rects: n, elements: o }) {
            Object.assign(o.floating.style, {
              width: `${n.reference.width}px`
            });
          }
        })
      ) : i.push(
        rt({
          apply({ rects: n, elements: o }) {
            Object.assign(o.floating.style, {
              minWidth: `${n.reference.width >= 172 ? n.reference.width : 172}px`,
              maxWidth: "80%"
            });
          }
        })
      ), ve(r, this.menu, {
        middleware: [ye(8), xe(), ...i],
        placement: "bottom-start"
      }).then(({ x: n, y: o }) => {
        Object.assign(this.menu.style, {
          left: `${n}px`,
          top: `${o}px`,
          position: "absolute",
          zIndex: 1
        });
      }).catch((n) => {
        console.warn(n);
      }), this.menu.children[0].focus();
    }, this.escapeKeyHandler = (i) => {
      i.code === "Escape" && (this.open = !1), et(this, "adc-dropdown-escape-keydown");
    }, this.handleTriggerClick = (i) => {
      this._browser === "safari" && i.target.focus(), this._touched = !0, this.open ? this.open = !1 : this.open = !0, et(this, "adc-dropdown-trigger-click");
    }, this.handleTriggerMouseDown = (i) => {
      this._browser === "safari" && i.preventDefault();
    }, this.getAriaDescription = () => {
      const i = [];
      this.ariaDescription && i.push(this.ariaDescription);
      const r = Array.from(this._describedByIds).map(
        (n) => {
          var o;
          return (o = document.querySelector(`#${n}`)) == null ? void 0 : o.textContent.trim();
        }
      );
      return i.push(...r), this.error && i.push(this.errorMessage), i.length > 0 ? i.join(", ") : "";
    }, this.customElementString = e;
  }
  /**
   * Gets custom tag name
   * @returns tagName
   */
  getTagName(e) {
    return this.customElementString ? this.customElementString + e : "adc" + e;
  }
  /**
   * Creates custom tag name
   */
  createTagName(e) {
    return zt(this.getTagName(e));
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-dropdown"), Bt(
      this.customElementString ? this.customElementString + "-dropdown" : "adc-dropdown"
    ), Mt(
      this.customElementString ? this.customElementString + "-dropdown" : "adc-dropdown"
    ), await this.updateComplete;
    const e = this.root.querySelector(
      `${this.getTagName("-dropdown-listbox")}`
    );
    e && (this._observer = new MutationObserver((o) => {
      o.forEach((s) => {
        if (s.type === "attributes") {
          const { value: a } = s.target;
          (a == null ? void 0 : a.length) > 0 ? (this.value = a, this._setDisplayNameAndLabelText(a), this.multiSelect || (this.open = !1), this.trigger.focus()) : this.value = null;
        }
      });
    }), this._observer.observe(e, {
      attributes: !0
    }));
    const i = await this.menu, r = await this.trigger, n = (o) => {
      !r.contains(o.relatedTarget) && !i.contains(o.relatedTarget) && (this.open = !1);
    };
    i.addEventListener("focusout", n), r.addEventListener("blur", n);
  }
  _buildValueObject(e) {
    let i = this.options.find((r) => typeof r == "object" ? r.value === e : r === e);
    return typeof i == "string" && (i = { value: i }), i && !(i != null && i.labelText) && (i.labelText = i.value), i && !(i != null && i.displayName) && (i.displayName = i.labelText), i;
  }
  /**
   * Sets the displayName and labelText of the selected item
   * @param value - String with the value selected
   */
  _setDisplayNameAndLabelText(e) {
    var n;
    const i = [], r = [];
    if (this.multiSelect)
      ((n = this.value) == null ? void 0 : n.split(", ")).forEach((s) => {
        const a = this._buildValueObject(s);
        i.push(a.displayName), r.push(a.labelText);
      });
    else {
      const o = this._buildValueObject(e);
      i.push(o.displayName), r.push(o.labelText);
    }
    this.displayName = i.join(", "), this.labelText = r.join(", ");
  }
  handleValueChanged() {
    et(this, "adc-dropdown-change");
  }
  /**
   * Sets listbox value to match dropdown pre-set value on first update
   */
  firstUpdated(e) {
    super.firstUpdated(e);
    const i = this.root.querySelector(
      `${this.getTagName("-dropdown-listbox")}`
    );
    this.value !== null && (i.value = this.value, this.value !== "" && this._setDisplayNameAndLabelText(this.value));
    const r = new Pt(navigator.userAgent);
    this._browser = r.getBrowser().toLowerCase();
  }
  willUpdate(e) {
    super.willUpdate(e), e.has("open") && !this.open && this._touched && (this.required && (this.value === null || this.value === "") ? this.error = !0 : this.error = !1), e.has("ariaDescribedBy") && (this.ariaDescribedBy ? this._describedByIds.add(this.ariaDescribedBy) : this._describedByIds.clear());
  }
  updated(e) {
    if (super.updated(e), e.has("open") && (this.open ? (this.root.classList.add(m.open), this.positionMenu()) : this.root.classList.remove(m.open)), e.has("value") && this.value !== null) {
      const i = this.root.querySelector(
        `${this.getTagName("-dropdown-listbox")}`
      );
      i.value = this.value, this.value !== "" && this._setDisplayNameAndLabelText(this.value);
    }
    e.has("secondary") && (this.secondary ? this.trigger.classList.add(m.secondary) : this.trigger.classList.remove(m.secondary)), e.has("ghost") && (this.ghost && !this.secondary ? this.trigger.classList.add(m.ghost) : this.trigger.classList.remove(m.ghost)), e.has("small") && (this.small && (this.ghost || this.secondary) ? this.trigger.classList.add(m.small) : this.trigger.classList.remove(m.small)), e.has("disabled") && (this.disabled ? (this.trigger.setAttribute("disabled", "true"), this.trigger.setAttribute("aria-disabled", "true")) : (this.trigger.removeAttribute("disabled"), this.trigger.setAttribute("aria-disabled", "false"))), e.has("error") && (this.error ? this.root.classList.add(m.error) : this.root.classList.remove(m.error));
  }
  render() {
    return Ft`
      <div class="${m.root}">
        <div class=${m.triggerContainer}>
          <button
            class=${m.trigger}
            @click=${this.handleTriggerClick}
            @mousedown=${this.handleTriggerMouseDown}
            aria-label="${this.ariaLabel ? this.ariaLabel : this.labelText}"
            aria-labelledby="${this.ariaLabelledBy || tt}"
            aria-description="${this.getAriaDescription() || tt}"
            aria-haspopup="true"
            aria-invalid="${this.error}"
            aria-required="${this.required}"
            aria-disabled=${this.disabled ? "true" : "false"}
            ?disabled=${this.disabled}
            id="${this.dropdownID ? this.dropdownID : this.randomID}"
          >
            <slot
              class=${m.prependIcon}
              name="prepend-icon"
              @slotchange=${this.handleSlotchange}
            >
            </slot>
            <span class=${m.triggerLabel}>
              ${this.value ? this.displayName : this.triggerLabel}
            </span>
            <${this.createTagName("-dropdown-icon")}
              class=${m.icon}
              size="24"
              icon=${this.open ? "navigation:caret-up" : "navigation:caret-down"}
                ></${this.createTagName("-dropdown-icon")}>
          </button>
          <div
            class=${m.errorMessage}
            id="${this.dropdownID ? this.dropdownID : this.randomID}--error"
          >
          <${this.createTagName(
      "-dropdown-icon"
    )} size="16" icon="signal:stop-alert"></${this.createTagName(
      "-dropdown-icon"
    )}
    ><span>${this.error ? this.errorMessage : ""}</span>
          </div>
        </div>
        <div class=${m.menu} @keydown=${this.escapeKeyHandler}>
        <${this.createTagName("-dropdown-listbox")}
            ?include-search=${this.includeSearch}
            .options=${this.options}
            ?required=${this.required}
            aria-label="${this.ariaLabel || tt}"
            aria-description="dropdown-menu"
            ?multi-select=${this.multiSelect}
            ></${this.createTagName("-dropdown-listbox")}>
        </div>
      </div>
    `;
  }
};
dt.styles = [wt.styles || [], kt(qt)];
let f = dt;
h([
  y({ type: Array })
], f.prototype, "options", 2);
h([
  y({ attribute: "include-search", type: Boolean })
], f.prototype, "includeSearch", 2);
h([
  y({ type: Boolean, reflect: !0 })
], f.prototype, "open", 2);
h([
  y({ type: String, reflect: !0 })
], f.prototype, "value", 2);
h([
  y({ type: Boolean })
], f.prototype, "ghost", 2);
h([
  y({ type: Boolean })
], f.prototype, "secondary", 2);
h([
  y({ type: Boolean })
], f.prototype, "small", 2);
h([
  y({ type: Boolean, reflect: !0 })
], f.prototype, "required", 2);
h([
  y({ type: String, attribute: "trigger-label" })
], f.prototype, "triggerLabel", 2);
h([
  y({ type: String, attribute: "error-message" })
], f.prototype, "errorMessage", 2);
h([
  y({ type: Boolean, reflect: !0 })
], f.prototype, "disabled", 2);
h([
  y({ type: Boolean, reflect: !0 })
], f.prototype, "error", 2);
h([
  y({ type: String, attribute: "aria-label" })
], f.prototype, "ariaLabel", 2);
h([
  y({ type: String, attribute: "aria-labelledby" })
], f.prototype, "ariaLabelledBy", 2);
h([
  y({ type: String, attribute: "aria-description" })
], f.prototype, "ariaDescription", 2);
h([
  y({ type: String, attribute: "aria-describedby" })
], f.prototype, "ariaDescribedBy", 2);
h([
  y({ attribute: "multi-select", type: Boolean, reflect: !0 })
], f.prototype, "multiSelect", 2);
h([
  y({ type: String, reflect: !0, attribute: "dropdown-id" })
], f.prototype, "dropdownID", 2);
h([
  y({ type: Boolean, reflect: !0, attribute: "fit-content-menu" })
], f.prototype, "fitContentMenu", 2);
h([
  P()
], f.prototype, "_touched", 2);
h([
  P()
], f.prototype, "_describedByIds", 2);
h([
  q(`.${m.menu}`)
], f.prototype, "menu", 2);
h([
  q(`.${m.trigger}`)
], f.prototype, "trigger", 2);
h([
  q(`.${m.root}`)
], f.prototype, "root", 2);
h([
  q(`.${m.errorMessage}`)
], f.prototype, "errorElement", 2);
h([
  P()
], f.prototype, "displayName", 2);
h([
  P()
], f.prototype, "labelText", 2);
h([
  ke("value", { waitUntilFirstUpdate: !0 })
], f.prototype, "handleValueChanged", 1);
try {
  customElements.define("adc-dropdown", f), console.warn(
    "@aileron/dropdown is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/dropdown"
  );
} catch {
}
function $e(t) {
  try {
    customElements.define(
      `${t}-dropdown`,
      class extends f {
        constructor() {
          super(t);
        }
      }
    );
  } catch (e) {
    if (!(e instanceof DOMException)) throw e;
  }
}
function Ne(t) {
  try {
    $e(t);
  } catch {
  }
}
export {
  f as Dropdown,
  Ne as registerComponent
};
